export const exterior_view05ImageOptions = {
  angle: 'exterior_view05',
  staticOptions: {
    HullColorways: 1,
    BowSpirit: 1,
    HullTreatment: 1,
    Deck: 1,
    TeakOnSideDecks: 1,
    TeakOnCoachroof: 1,
    Sprayhood: 1,
    MastAndBoom: 1,
    BoomCover: 1
  },
  mattes: [
    {
      option: 'HullColorways',
      dependency: null
    },
    {
      option: 'HullTreatment',
      dependency: null
    },
    {
      option: 'Sprayhood',
      dependency: null
    },
    {
      option: 'MastAndBoom',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/XC45/views/exterior_view05.js